import React from 'react';
import Sidebar from './Sidebar';

// Navigation is now handled by Sidebar component
// This component is kept for backward compatibility
const Navigation = () => {
  return <Sidebar />;
};

export default Navigation;
